import React from 'react';
import PropTypes from 'prop-types';

const List = props => {
  const { Container, className, items, renderItem } = props;

  return <Container className={className}>{items.map(renderItem)}</Container>;
};

List.propTypes = {
  Container: PropTypes.string,
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
};

List.defaultProps = {
  Container: 'div',
};

export default List;



// WEBPACK FOOTER //
// ./src/modules/common/components/List.js